import * as types from "../../constants/action-types";

export function setOrderNotReceived(payload) {
    return {type: types.SET_ORDER_NOT_RECEIVED, payload};
}

export function setMailLinkPage(payload) {
    return {type: types.SET_MAIL_LINK_PAGE, payload};
}

export function setLandingPageData(payload) {
    return {type: types.SET_LANDING_PAGE_DATA, payload};
}

export function setVerificationStatus(payload) {
    return {type: types.SET_VERIFICATION, payload}
}

export function setFilters(payload) {
    return {type: types.SET_FILTERS, payload}
}

export function setOnlyBenefits(payload) {
    return {type: types.SET_ONLY_BENEFITS, payload}
}

export function setOnlyTrades(payload) {
    return {type: types.SET_ONLY_TRADES, payload}
}

export function setCouponPayResult(payload) {
    return {type: types.SET_COUPON_PAY_RESULT, payload};
}

export function setIsUserApprovedMarketing(payload) {
    return {type: types.SET_IS_MARKETING_APPROVED, payload};
}

export function setStreetList(payload) {
    return {type: types.SET_STREET_LIST, payload};
}

export const AUTOCOMPLETE_STATUS = {
    IDLE: 'IDLE',
    LOADING: 'LOADING',
    RESULTS: 'RESULTS',
    NO_RESULTS: 'NO_RESULTS',
    ERROR: 'ERROR',
};

export function setAutocompleteResults(payload) {
    return {type: types.SET_AUTOCOMPLETE_RESULTS, payload};
}

export function setAutocompleteStatus(payload) {
    return {type: types.SET_AUTOCOMPLETE_STATUS, payload};
}

export function setContactPage(payload) {
    return {type: types.SET_CONTACT_PAGE, payload};
}

export function setContentData(payload) {
    return {type: types.SET_CONTENT_DATA, payload};
}

export function setOurStory(payload) {
    return {type: types.SET_OUR_STORY, payload};
}

export function setBenefitPage(payload) {
    return {type: types.SET_BENEFIT_PAGE, payload};
}

export function setHomepageData(payload) {
    return {type: types.SET_HOMEPAGE_DATA, payload};
}

export function setHomepageSecondarySliders(payload) {
    return {type: types.SET_HOMEPAGE_SECONDARY_SLIDERS, payload};
}

export function setAppDownStatus(payload) {
    return {type: types.SET_APP_DOWN_STATUS, payload};
}

export function setLeadSatus(payload) {
    return {type: types.SET_LEAD_STATUS, payload};
}

export function setFilteredBenefits(payload) {
    return {type: types.SET_FILTERED_BENEFITS, payload};
}

export function addFilteredBenefits(payload) {
    return {type: types.ADD_FILTERED_BENEFITS, payload};
}

export function setNewsletterStatus(payload) {
    return {type: types.SET_NEWSLETTER_STATUS, payload};
}

export function setNewsletterSubscriptionResultText(payload) {
    return {type: types.SET_NEWSLETTER_SUBSCRIPTION_RESULT_TEXT, payload};
}

export function setMetaTages(payload) {
    return {type: types.SET_META_TAGS, payload};
}

export function setPinBenefits(payload) {
    return {type: types.SET_PIN_BENEFITS, payload};
}

export function setFreeSearchData(payload) {
    return {type: types.SET_FREE_SEARCH_DATA, payload};
}

export function setFreeSearchRecords(payload) {
    return {type: types.SET_FREE_SEARCH_RECORDS, payload};
}
export function resetFreeSearchRecords(payload) {
    return {type: types.RESET_FREE_SEARCH_RECORDS, payload};
}

export function setPolicyPageId(payload) {
    return {type: types.SET_POLICY_PAGE_ID, payload};
}

export function resetPinBenefits() {
    return {type: types.RESET_PIN_BENEFITS};
}

export function setSuppliersJoinPage(payload) {
    return {type: types.SET_SUPPLIER_JOIN_PAGE, payload};
}

export function setClientsJoinPage(payload) {
    return {type: types.SET_CLIENT_JOIN_PAGE, payload};
}

export function setUserApp(payload) {
    return {type: types.SET_USER_APP, payload};
}

export function setSuppApp(payload) {
    return {type: types.SET_SUPP_APP, payload};
}

export function setBenefitStatus(payload) {
    return {type: types.SET_BENEFIT_STATUS, payload}
}

export function resetBenefitStatus() {
    return {type: types.RESET_BENEFIT_STATUS};
}

export function setVIPBenefitStatus(payload) {
    return {type: types.SET_VIP_BENEFIT_STATUS, payload}
}

export function setVipErrorMsg(payload) {
    return {type: types.VIP_MESSAGE, payload}
}

export function setWalletPage(payload) {
    return {type: types.SET_WALLET_PAGE, payload}
}

export function setMembershipPage(payload) {
    return {type: types.SET_MEMBERSHIP_PAGE, payload}
}

export function setLoginCode(payload) {
    return {type: types.SET_LOGIN_CODE, payload}
}

export function setLoginId(payload) {
    return {type: types.SET_LOGIN_ID, payload}
}


export function setUserIdLogin(payload){
    return {type: types.SET_USER_ID_LOGIN, payload}
}

export function setUserPhoneLogin(payload){
    return {type: types.SET_USER_PHONE_LOGIN, payload}
}
export function setIsFirstRegistrationNeeded(payload){
    return {type: types.SET_IS_FIRST_REGISTRATION_NEEDED, payload}
}


export function setMembershipReturn(payload) {
    return {type: types.SET_MEMBERSHIP_RETURN, payload}
}

export function setMembershipErr(payload) {
    return {type: types.SET_MEMBERSHIP_ERR, payload}
}

export function setLoginReturn(payload) {
    return {type: types.SET_LOGIN_RETURN, payload}
}

export function setValidateHotUserReturn(payload){
    return {type: types.SET_VALIDATE_HOT_USER_RETURN, payload};
}

export function setDynamicLink(payload) {
    return {type: types.SET_DYNAMIC_LINK, payload}
}

export function setUserFavorites(payload) {
    return {type: types.SET_FAVORITES_DATA, payload}
}

export function updateAddFavorite(payload) {
    return {type: types.ADD_FAVORITE, payload}
}

export function updateRemoveFavorite(payload) {
    return {type: types.REMOVE_FAVORITE, payload}
}

export function setBenefitAcquired(payload) {
    return {type: types.SET_BENEFIT_ACQUIRED, payload}
}

export function setBenefitAcquiredErr(payload) {
    return {type: types.SET_BENEFIT_ACQUIRED_ERR, payload}
}

export function otpResponse(payload) {
    return {type: types.OTP_RESPONSE, payload}
}

export function setTelecardUrl(payload) {
    return {type: types.SET_TELECARD_URL, payload}
}

export function setAvailableCoupon(payload) {
    return {type: types.SET_AVAILABLE_COUPON, payload}
}

export function setAvailableCouponErr(payload) {
    return {type: types.SET_AVAILABLE_COUPON_ERR, payload}
}

export function setBenefitPurchased(payload) {
    return {type: types.SET_BENEFIT_PURCHASED, payload}
}

export function setExpertsPage(payload) {
    return {type: types.SET_EXPERTS_PAGE, payload}
}

export function setExpertsLead(payload) {
    return {type: types.SET_EXPERT_LEAD, payload}
}

export function setCoupon(payload) {
    return {type: types.SET_COUPON, payload};
}

export function setUserOrders(payload) {
    return {type: types.SET_USER_ORDERS, payload};
}

export function setUserOrder(payload) {
    return {type: types.SET_USER_DETAILED_ORDER, payload};
}

export function setOrderSmartWallet(payload) {
    return {type: types.SET_ORDER_SMART_WALLET, payload};
}

export function setVehicleAdsPage(payload) {
    return {type: types.SET_VEHICLE_ADS_PAGE, payload};
}

export function setVehicleAdsOnSuccess(payload) {
    return {type: types.SET_VEHICLE_ADS_ON_SUCCESS, payload};
}

export function setTutorialDisplayNumber(payload) {
    return {type: types.SET_TUTORIAL_DISPLAY_NUMBER, payload};
}

export function setBenefitsArray(payload) {
    return {type: types.SET_BENEFITS_ARRAY, payload};
}

export function setSearchBenefitsArray(payload) {
    return {type: types.SET_SEARCH_BENEFITS_ARRAY, payload};
}

export function setShouldShowTabs(payload) {
    return {type: types.SET_SHOULD_SHOW_TABS, payload};
}

export function setLeadFormValid(payload) {
    return {type: types.SET_LEAD_FORM_VALID, payload};
}

export function addMagainzeCrumb(payload) {
    return {type: types.ADD_MAGAZINE_CRUMB, payload};
}

export function setMagazineCategories(payload) {
    return {type: types.SET_MAGAZINE_CATEGORIES, payload};
}

export function setHomepageMagazineArticles(payload) {
    return {type: types.SET_HOMEPAGE_MAGAZINE_ARTICLES, payload};
}

export function setLegalAdvicePage(payload) {
    return {type: types.SET_LEGAL_ADVICE_PAGE, payload};
}

export function setLegalAdviceQuestion(payload) {
    return {type: types.SET_LEGAL_ADVICE_QUESTION, payload};
}

export function resetLegalAdviceQuestion() {
    return {type: types.RESET_LEGAL_ADVICE_QUESTION};
}

export function setLegalAdviceQuestions(payload) {
    return {type: types.SET_LEGAL_ADVICE_QUESTIONS, payload};
}

export function setLegalAdviceQuestionResults(payload) {
    return {type: types.SET_LEGAL_ADVICE_QUESTION_RESULTS, payload};
}

export function resetLegalAdviceQuestionResults() {
    return {type: types.RESET_LEGAL_ADVICE_QUESTION_RESULTS};
}

export function setLegalAdviceQuestionSubmit(payload) {
    return {type: types.SET_LEGAL_ADVICE_QUESTION_SUBMIT, payload};
}

export function resetLegalAdviceQuestionSubmit() {
    return {type: types.RESET_LEGAL_ADVICE_QUESTION_SUBMIT};
}

export function setAllBenefits(payload) {
    return {type: types.SET_ALL_BENEFITS, payload};
}


export function setAllFilters(payload) {
    return {type: types.SET_ALL_FILTERS, payload};
}



export function setCategoryBenefits(payload) {
    return {type: types.SET_CATEGORY_BENEFITS, payload};
}

export function setHomepageSearchQuery(payload) {
    return {type: types.SET_HOMEPAGE_SEARCH_QUERY, payload};
}
